import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxGoToastComponent } from 'ngx/go-modules/src/components/go-toast/go-toast.component';
import { NgxGoToastService } from 'ngx/go-modules/src/services/go-toast/go-toast.service';

export const ngxGoToastModule = angular.module('ngxGoToastModule', [])
	.directive('ngxGoToast', downgradeComponent({ component: NgxGoToastComponent }))
	.factory('ngxGoToastService', downgradeInjectable(NgxGoToastService) as any)
	.name;
